export default __webpack_public_path__ + "static/media/PC-03.10de5497.jpg";